import * as React from 'react'
import {ReactElement} from 'react'
import {Box} from '@mui/material'
import {Colors} from '../../../../styledComponents/Constants'
import {FullWidthColumnFlexContainer} from '../../../../styledComponents/FlexComponents'
import {BlockSpacer} from '../../../../styledComponents/ResponsiveConvenience'
import {PlainBackLink} from '../../../../styledComponents/Links'
import {DisplayItemDividerForPageTop} from '../../../../styledComponents/DisplayItem'
import {
    ApplyButton,
    BoldText,
    ListGridContainer,
    PageTitle,
    WideWhiteArea,
} from '../common/resident/NatResidentApplicationsCommon'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet,
} from '../../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    applyId?: string
    location: Location
}

class NatResidentPetMedicalCheckUpReportAgreementPage
    extends React.Component<Props & ResidentWithErrorHandlingPagePropsSet> {

    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props)

        this.onClickApplyButton = this.onClickApplyButton.bind(this)
    }

    onClickApplyButton(): void {
        this.props.navigate(
            `/resident/condominiums/${this.props.condominiumCd}/applications/petMedicalCheckUpReport/input`,
            {
                state: {
                    applyId: this.props.applyId,
                },
            },
        )
    }

    render(): ReactElement {
        return (
            <>
                <PlainBackLink
                    to={this.props.applyId
                        ? `/resident/condominiums/${this.props.condominiumCd}/applications/petMedicalCheckUpReport/${this.props.applyId}`
                        : `/resident/condominiums/${this.props.condominiumCd}/applications`}>
                    戻る
                </PlainBackLink>
                <BlockSpacer height={'16px'}/>
                <DisplayItemDividerForPageTop/>
                <BlockSpacer height={'30px'}/>
                <PageTitle>
                    健康診断報告書
                </PageTitle>
                <Box height={'20px'}/>
                <Box>
                    犬を飼育する場合に毎年必ず提出が必要です。なお、管理組合から指示された場合は、猫や小動物についても提出いただくことがあります。
                </Box>
                <Box height={'15px'}/>
                <WideWhiteArea>
                    <Box mt={'15px'}>
                        <BoldText fontColor={Colors.AccentDark}>ご提出いただくもの</BoldText>
                        <Box height={'5px'}/>
                        <ListGridContainer fontSize={'16px'}>
                            <div>・</div>
                            <div>
                                保健所犬鑑札
                            </div>
                            <div>・</div>
                            <div>
                                狂犬病予防注射済証
                            </div>
                            <div>・</div>
                            <div>
                                健康診断書
                            </div>
                        </ListGridContainer>
                        <Box height={'5px'}/>
                        <div>
                            ※猫や小動物の場合は健康診断書のみ
                        </div>
                        <Box height={'20px'}/>
                    </Box>
                </WideWhiteArea>
                <ApplyButton
                    onClick={this.onClickApplyButton}>
                    <FullWidthColumnFlexContainer>
                        <div>
                            申請を開始する
                        </div>
                    </FullWidthColumnFlexContainer>
                </ApplyButton>
            </>
        )
    }
}

export default createResidentWithErrorHandlingPage(NatResidentPetMedicalCheckUpReportAgreementPage)
